var React = require('react');

function Defs (props) {
    return React.createElement("svg",props,React.createElement("defs",null,[React.createElement("clipPath",{"id":"c0d_1","key":0},React.createElement("path",{"d":"M24.5,38.2c.8,0,1.5,-.7,1.5,-1.5V27.3l9.1,-12H13.8l9.1,12v9.4c0,.8,.7,1.5,1.6,1.5Zm0,3.1c-2.6,0,-4.6,-2.1,-4.6,-4.6V28.3L9.5,14.7C9,14,9.1,13,9.8,12.5c.3,-.2,.6,-.3,.9,-.3H38.2c.8,0,1.5,.7,1.5,1.6c0,.3,-.1,.6,-.3,.9L29,28.3v8.4c0,2.5,-2,4.6,-4.5,4.6Z"})),React.createElement("style",{"type":"text/css","key":1},"\n.g0_1{\nfill: #C30064;\n}\n")]));
}

Defs.defaultProps = {"id":"icon-defs","x":"0","y":"0","width":"0","height":"0","viewBox":"0 0 0 0","version":"1.1"};

module.exports = Defs;

Defs.default = Defs;
